/**
 * Configuration for user identification retry mechanism
 */

/**
 * Maximum number of retry attempts before giving up
 */
export const MAX_RETRY_ATTEMPTS = 5;

/**
 * Progressive backoff intervals for retries (in milliseconds)
 * Starts aggressive (2s) to catch OIDC tokens as soon as they're available,
 * then backs off progressively.
 * [2s, 5s, 10s, 30s, 60s]
 */
export const RETRY_INTERVALS = [
	2000,
	5000,
	10000,
	30000,
	60000,
];

/**
 * Period after which retry attempts are reset (24 hours in milliseconds)
 */
export const ATTEMPT_RESET_PERIOD = 86400000;

/**
 * Expiration time for identification cache (5 minutes in milliseconds)
 */
export const EXPIRATION = 300000;
